export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3" style={{ fontFamily: "var(--font-heading)" }}>
          平台优势
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">为什么数百万影迷选择桃子视频？这就是答案</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-4xl mx-auto">
          {/* Feature 1 */}
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-5 rounded-2xl flex items-center justify-center bg-primary-100 text-primary-500">
              <i className="ri-speed-up-line text-2xl"></i>
            </div>
            <h3 className="text-lg font-bold text-foreground-900 mb-3">极速更新不缓冲</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              多 CDN 节点智能加速，片源每日更新 200+ 部。无论是热门大片还是冷门佳片，都能享受流畅的超清播放体验，告别加载等待。
            </p>
          </div>

          {/* Feature 2 */}
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-5 rounded-2xl flex items-center justify-center bg-accent-100 text-accent-500">
              <i className="ri-global-line text-2xl"></i>
            </div>
            <h3 className="text-lg font-bold text-foreground-900 mb-3">十大品牌一站聚合</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              聚合香蕉视频、西瓜视频、蜜桃视频、樱桃视频等 10+ 水果品牌资源，无需切换多个平台，一个网站看遍全网热门内容。
            </p>
          </div>

          {/* Feature 3 */}
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-5 rounded-2xl flex items-center justify-center bg-secondary-100 text-secondary-500">
              <i className="ri-shield-star-line text-2xl"></i>
            </div>
            <h3 className="text-lg font-bold text-foreground-900 mb-3">纯净观影无打扰</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              全站无弹窗广告，无强制注册，无需付费订阅。打开即看、即点即播，把每一分钟都还给纯粹的观影乐趣。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}